<script>
import TheGuestAccountMenu from "./TheGuestAccountMenu.vue";
import TheUserAccountMenu from "./TheUserAccountMenu.vue";

export default {
  name: "TheAccountMenu",
  components: {TheUserAccountMenu, TheGuestAccountMenu},
  props: {
    isGuest: {
      type: Boolean,
      default: true,
    },
  }
}
</script>

<template>
  <div class="submenu offcanvas offcanvas-end w-100" tabindex="-1" id="offcanvasSubmenu0">
    <div class="offcanvas-header d-flex align-items-center bg-ck-blue text-white px-3">
      <h5 class="submenu-title my-0" data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar"><i
          class="fa-solid fa-chevron-left"></i> BACK</h5>
      <i class="close-submenu fa-solid fa-xmark fs-2" aria-label="Close" data-bs-dismiss="offcanvas"></i>
    </div>
    <div class="" id="submenu0">
      <h2 class="submenu-callout-link" id="submenu0-item0-header">
        MY ACCOUNT
      </h2>
      <the-guest-account-menu v-if="isGuest" />
      <the-user-account-menu v-else />
    </div>
  </div>
</template>
